import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed } from "src/utils/lazy-named";

const sequencesImport = () => import("./sequences");

const CreateSequence = lazyNamed(
  () => import("./create-sequence"),
  "CreateSequence",
);
const Sequence = lazyNamed(() => import("./sequence"), "Sequence");
const SequenceLoader = lazyNamed(() => import("./sequence"), "SequenceLoader");
const Sequences = lazyNamed(sequencesImport, "Sequences");

export const preloads: RoutePreload[] = [["/sequences", sequencesImport]];
const SequenceRuns = lazyNamed(() => import("./sequence/runs"), "SequenceRuns");
const SequenceConfiguration = lazyNamed(
  () => import("./sequence/configuration"),
  "SequenceConfiguration",
);
const SequenceSchedule = lazyNamed(
  () => import("./sequence/schedule"),
  "SequenceSchedule",
);

export const routes: Array<RouteObject> = [
  {
    path: "sequences",
    element: <Sequences />,
    spacesAccess: "hidden-from-limited-view",
  },
  {
    path: "sequences/new",
    element: <CreateSequence />,
    spacesAccess: "hidden-from-limited-view",
  },
  {
    path: "sequences/:id/*",
    element: <SequenceLoader />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        element: <Sequence />,
        spacesAccess: "hidden-from-limited-view",
        children: [
          {
            index: true,
            element: (
              <Navigate
                to={{ pathname: "runs", search: location.search }}
                replace
              />
            ),
            spacesAccess: "hidden-from-limited-view",
          },
          {
            path: "runs",
            element: <SequenceRuns />,
            spacesAccess: "hidden-from-limited-view",
          },
          {
            path: "configuration",
            element: <SequenceConfiguration />,
            spacesAccess: "hidden-from-limited-view",
          },
          {
            path: "schedule",
            element: <SequenceSchedule />,
            spacesAccess: "hidden-from-limited-view",
          },
        ],
      },
    ],
  },
];
